/**
 * Admin Token Usage page component.
 *
 * Route: `/admin/token-usage`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminTokenUsagePage
 */

import TokenUsageManager from '@/components/admin/TokenUsageManager';

export default function AdminTokenUsagePage() {
  return <TokenUsageManager />;
}
